import { Link } from "react-router-dom";

const FRIEND_LINKS = [
  { label: "动漫资讯站", href: "https://ycwgxs.com" },
  { label: "正版片源联盟", href: "https://ycwgxs.com" },
  { label: "动画制作委员会", href: "https://ycwgxs.com" },
  { label: "声优情报馆", href: "https://ycwgxs.com" },
];

export default function Footer() {
  return (
    <footer className="mt-16 border-t border-secondary-200 bg-secondary-50">
      <div className="w-full px-4 py-12 md:px-6 lg:px-10">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-500 text-background-50 text-xl">
                <i className="ri-flower-fill"></i>
              </span>
              <span className="text-lg font-bold text-foreground-950">樱花动漫</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
              樱花动漫专注提供正版、完整版动漫在线观看，内容覆盖热门新作与经典动画。我们尊重版权、倡导合规观影，愿每一位动漫爱好者都能在这里找到属于自己的那份心动。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950">
              <a href="#site-links" className="hover:text-primary-600">快捷导航</a>
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-600">
              <li><Link to="/" className="hover:text-primary-600">首页</Link></li>
              <li><Link to="/category/all" className="hover:text-primary-600">动漫分类</Link></li>
              <li><Link to="/search" className="hover:text-primary-600">搜索动漫</Link></li>
              <li><Link to="/about" className="hover:text-primary-600">关于我们</Link></li>
            </ul>
          </div>

          <div id="site-links">
            <h4 className="text-sm font-semibold text-foreground-950">
              <a href="#site-links" className="hover:text-primary-600">友情链接</a>
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-600">
              {FRIEND_LINKS.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    target="_blank"
                    rel="noopener"
                    className="hover:text-primary-600"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-secondary-200 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 樱花动漫 Sakura Anime. 保留所有权利。本站为演示站点，内容仅供产品展示。</p>
          <p>本站所有动漫资源版权归原作品方所有，如涉侵权请联系我们删除。</p>
        </div>
      </div>
    </footer>
  );
}